import { Container, Grid } from "@mui/material";

import React, { useRef, useState } from "react";
import Minaimg from "../../../../assets/images/compimg.png";
import telegram from "../../../../assets/images/telegram.png";
import twitter from "../../../../assets/images/twitter.png";
import medium from "../../../../assets/images/medium.png";
import styled from "@emotion/styled";
import {
  Heading,
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionMainWrapper,
  SectionWrapper,
  TransBtn,
} from "../../../Styles/style";

const MainImg = styled.img`
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "700px")};
`;
const MainGrid = styled(Grid)`
  display: flex;
  justify-content: space-between;
  background: rgb(235, 235, 254);
  background: linear-gradient(
    135deg,
    rgba(251, 251, 255, 1) 10%,
    rgba(235, 243, 254, 1) 100%
  );
  /* background:red; */
  border-radius: 20px;
  padding: 5% 0 0 5%;
  @media screen and (max-width: 900px) {
    display: grid;
  }
`;
const BoxGren = styled.div`
  padding: 5px;
  margin-right: 7px;
  background-color: ${(props) =>
    props.bgcolors ? props.bgcolors : props.theme.Approvecolor};
  border: 1px solid ${(props) => props.theme.textPrimary};
`;
const GridText = styled(Grid)`
  text-align: left;
  /* display: flex;
justify-content: flex-end;
flex-direction: column;
align-self: flex-start; */
`;

const ConnectButt = styled.button`
  background-color: ${(props) =>
    props.bgcolor ? props.bgcolor : props.theme.btnPrimary};
  width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "40%")};
  margin: ${(props) => (props.m ? props.m : "")};
  padding: ${(props) => (props.p ? props.p : "11px 0px")};
  font-family: "Poppins-Medium";
  font-size: 15px;
  color: ${(props) => props.theme.textPrimary};
  text-decoration: none;
  cursor: pointer;
  border: 1px solid
    ${(props) => (props.border ? props.border : props.theme.textPriamry)};
  @media screen and (max-width: 599px) {
    max-width: ${(props) => (props.mw ? props.mw : "50%")};
  }
`;
const ScialDIv = styled.div`
  display: flex;
  align-items: center;
  place-items: flex-end;
`;
const SOcialIm = styled.img`
  width: 100%;
  max-width: 20px;
  /* padding-right: 10px; */
  margin-right: 10px;
`;
const A = styled.a``;
const S1_Header = () => {
  return (
    <div>
      <SectionMainWrapper>
        <Container maxWidth="xl">
          <MainImg
            data-aos="zoom-in"
            data-aos-duration="1000"
            src={Minaimg}
          />
          <Grid container>
            <Grid item xs={12} md={6} 
                data-aos="fade-right"
                data-aos-duration="1000">
              <Heading
                fs599="13px"
                p599="40PX 0 10PX"
              >
                <BoxGren />
                Privacy-First Web3 Wallet
              </Heading>
              <SectionHeading
              >
                Multi-Chain
                <br />
                Security And Privacy
                <br />
                Solution
              </SectionHeading>
              <P
                maxWidth="70%"
                m="0"
                p="10px 0"
              >
                Incognito cutting-edge fusion of blockchain technology and
                personal privacy. Experience a new era of secure, confidential
                cryptocurrency transactions and DApp exploration
              </P>
            </Grid>
            <Grid md={2} />
            <GridText item xs={12} md={4} data-aos="fade-left"
                data-aos-duration="1000">
              <P
                maxWidth="70%"
                m="0"
                p="10px 0"
                
              >
                We provide the safest and easiest-to-use privacy-first web3
                wallet.
              </P>

              <a href="/comingsoon">
                <ConnectButt
                  
                >
                  Create Wallet{" "}
                </ConnectButt>
              </a>
              <ScialDIv>
                <P
                  p="20px 10px 0 0"
                  m="0"
                  fs="20px"
                  
                >
                  Follow us:
                </P>
                <A
                  href="#"
                  target="blank"
                  
                >
                  <SOcialIm src={twitter} />
                </A>
                <A
                  href="#"
                  target="blank"
                  
                >
                  <SOcialIm src={telegram} />
                </A>
                <A
                  href="#"
                  target="blank"
                  
                >
                  <SOcialIm src={medium} />
                </A>
              </ScialDIv>
            </GridText>
          </Grid>
        </Container>
      </SectionMainWrapper>
    </div>
  );
};

export default S1_Header;
